export default __webpack_public_path__ + "static/media/codru.fba05868.png";